import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { ScanSetupState } from './types'
import { cloneDeep, set } from 'lodash'

export const scanSetupStoreDefaults: ScanSetupState = {
    scanSetup: {
        // scanner: '',
        settings: {
            pixelType: 1, // (COLOR) TWPT_RGB -> DynamsoftEnumsDWT.EnumDWT_PixelType.TWPT_RGB -> 1
            resolution: 150,
            bFeeder: true,
            bDuplex: true,
        },
        ui: {
            bShowUI: false,
        },
    },
    spark: {
        autoCatalog: false,
        barcodeReader: true,
        blankPageSeparator: true,
        ignoreBlankPages: false,
    },
}

export const useScanSetupStore = create<ScanSetupState>()(
    persist(
        devtools((set, get) => scanSetupStoreDefaults, { name: 'ScanSetupStore' }),
        { name: 'scan-setup' },
    ),
)
export const getScanSetup = () => useScanSetupStore.getState()
export const setScanSetup = (settings: ScanSetupState) => useScanSetupStore.setState(settings)

export const resetDefaultScanSetup = (scanner?: string) => {
    const obj = cloneDeep(scanSetupStoreDefaults)
    if (scanner) {
        set(obj, 'scanSetup.scanner', scanner)
    }

    return useScanSetupStore.setState(obj)
}
